import React, { useState, useEffect } from 'react'
import { Paper, TableBody, TableRow, TableCell, Button, TextField, IconButton, } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import makemyStyles from "../Sharedfeatures/SharedStyles";
import PageHeader from "../Common/PageHeader";
import HeadCells from "../Common/HeadCells";
import moment from 'moment';
import { DatePicker } from 'antd';
import useTable from "../Sharedfeatures/useTable";
import ProgressSpinner from "../Common/ProgressSpinner";
import { PAGE_SIZE } from "../../utils/variable";
import { BsSearch } from "react-icons/bs";
import DownloadIcon from '@mui/icons-material/Download';
import useExcelDownload from '../Sharedfeatures/useExcelDownload'
import debounce from "lodash/debounce";
import { useMemo } from 'react';
import { IN_PROGRESS_REPAYMENTS_HEADER, IN_PROGRESS_REPAYMENTS_SUB_HEADER } from '../../utils/pageHeadings';
import { getInProgressRepaymentsDataExcel, getInProgressRepaymentsList } from '../../slice/inProgressRepaymentSlice';


const InProgressRepayments = () => {

    //For getting today and yesterday date
    let today = new Date();
    //let yesterday = new Date();
    let today_dd = String(today.getDate()).padStart(2, '0');
    //let yest_dd = String(today.getDate() - 1).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0');
    let yyyy = today.getFullYear();
    today = yyyy + '-' + mm + '-' + today_dd;
    //yesterday = yyyy + '-' + mm + '-' + yest_dd;

    const [excelSheetData, setExcelSheetData] = useState([]);
    const classes = makemyStyles();
    const dispatch = useDispatch();
    const [search, setSearch] = useState("");
    const [showPageNtn, setShowPageNtn] = useState(false);
    const [fromDate, setFromDate] = useState(``);
    const [toDate, setToDate] = useState(``);
    const dateFormat = 'YYYY-MM-DD';
    const { RangePicker } = DatePicker;

    const { inProgressRepaymentsList, totalCount, isLoading, inProgressRepaymentsDataExcel } = useSelector((store) => store.inprogressrepaymentsapi);

    const { TblContainer, TblHead, TblPagination, pageNo, slNo, handleChange } = useTable(inProgressRepaymentsList, HeadCells.inProgressRepayments, totalCount);

    const onDateChange = (dates, dateStrings) => {
        setFromDate(dateStrings[0]);
        setToDate(dateStrings[1]);
    }

    useEffect(() => {
        const dates = {
            searchQry: search,
            pageNo,
            fromDate,
            toDate,
        }
        dispatch(getInProgressRepaymentsList(dates))
        setShowPageNtn(true);
    }, [fromDate, toDate, pageNo, search, dispatch])

    let serialNo = PAGE_SIZE * slNo;

    const handleSearch = (e) => {
        setSearch(e.target.value)
        handleChange(null, 1)
    }
    const excelData = useExcelDownload()
    const debouncedResults = useMemo(() => {
        return debounce(handleSearch, 500);
    }, []);
    useEffect(() => {
        let excelsheetdata = []
        inProgressRepaymentsDataExcel?.map(item => {
            excelsheetdata.push({                
                "RT/DT Code" : item.dtcode,
                "Tranche Id" : item.trancheid,
                "Name" : item.name,
                "Tranche Amount" : item.trancheamount,
                "Loan Amount" : item.loanAmount,
                "Payable" : item.payable,
                "Payback Date" : moment(item.payback_date).format('DD MMMM YYYY'),
            })
        })
        setExcelSheetData(excelsheetdata)
    }, [inProgressRepaymentsDataExcel])
    const downloadExcelsheet = ()=>{
        const data = {
            searchQry: search,
            pageNum: pageNo,
            fromDate,
            toDate,
            totalCount
        };
        dispatch(getInProgressRepaymentsDataExcel(data))
        .then(res=>{
            if(res.payload.success === true){
            let excelsheetdata = []
            res.payload.data?.map(item=>{
                excelsheetdata.push({                
                    "RT/DT Code" : item.dtcode,
                    "Tranche Id" : item.trancheid,
                    "Name" : item.name,
                    "Tranche Amount" : Number(item.trancheamount).toFixed(2),
                    "Loan Amount" : Number(item.loanAmount).toFixed(2),
                    "Payable" : Number(item.payable).toFixed(2),
                    "Payback Date" : moment(item.payback_date).format('DD MMMM YYYY'),
                })
            })
            excelData.generateExcelFile(excelsheetdata, 'In Progress Repayments', 'inprogressrepayments.xlsx')
            }
        })
        .catch(err=>{
            console.error(err);
        })
    }
    return (
        <>
            <Paper className={classes.pageContent}>
                <PageHeader
                    header={IN_PROGRESS_REPAYMENTS_HEADER}
                    subHeader={IN_PROGRESS_REPAYMENTS_SUB_HEADER}
                />

                {/* <Box sx={{ height: '105px' }} /> */}
                <div style={{display:'flex', gap:'20px', alignItems:'flex-start', justifyContent:'space-between', flexWrap:'wrap'}} >
                    <TextField
                        size="small"
                        className={classes.searchTextBar}
                        //value={search}
                        onChange={debouncedResults}
                        id="standard-bare"
                        variant="outlined"
                        placeholder="Search Name or RT/DT Code"
                        InputLabelProps={{ shrink: false }}
                        InputProps={{
                            endAdornment: (
                                <IconButton>
                                    <BsSearch className={classes.searchIconColour} />
                                </IconButton>
                            ),
                        }}
                    />
                    <div style={{display:'flex', alignItems:"center", justifyContent:'space-between', flexWrap:'wrap', gap:'20px'}}>
                        <RangePicker
                            placeholder={["From Date", "To Date"]}
                            format={dateFormat}
                            //defaultValue={[moment(`${today}`, dateFormat), moment(`${today}`, dateFormat)]}
                            className={classes.noExcelDatePicker}
                            onChange={onDateChange}
                            //disabledDate={disableDates}
                            //allowClear={false}
                        />
                        <Button className={classes.excelUploadButton}
                            onClick={downloadExcelsheet}
                            disabled = {totalCount === 0 ? true : false}
                            endIcon={<DownloadIcon />}>Download Ledger
                        </Button>
                    </div>
                </div>

                <Paper className={classes.tableBoxShadow}>
                    <TblContainer>
                        <TblHead />
                        {
                            isLoading ? (
                                <TableBody>
                                    <TableRow>
                                        <TableCell
                                            colSpan={10}
                                            align="center"
                                            className={classes.tableCell}
                                        >
                                            <ProgressSpinner />
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            ) : (
                                <TableBody>
                                    {
                                        (inProgressRepaymentsList?.length !== 0) ? (
                                            inProgressRepaymentsList && inProgressRepaymentsList?.map((item, key) => {
                                                key++;
                                                serialNo++;
                                                return (
                                                    <TableRow key={key}>
                                                        <TableCell className={classes.tableCell}>{serialNo}</TableCell>
                                                        <TableCell className={classes.tableCell}>{item.dtcode}</TableCell>
                                                        <TableCell className={classes.tableCell}>{item.trancheid}</TableCell>
                                                        <TableCell className={classes.tableCell}>{item.name}</TableCell>
                                                        <TableCell className={classes.tableCell}>{item.trancheamount}</TableCell>
                                                        <TableCell className={classes.tableCell}>{item.loanAmount}</TableCell>
                                                        <TableCell className={classes.tableCell}>{item.payable}</TableCell>
                                                        <TableCell className={classes.tableCell}>
                                                        {moment(item.payBackDate).format('DD MMMM YYYY')}</TableCell>
                                                        <TableCell className={classes.tableCell}>{item.status_text}</TableCell>
                                                    </TableRow>
                                                )
                                            })
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={10} align='center'>No Data to Show</TableCell>
                                            </TableRow>
                                        )
                                    }
                                </TableBody>
                            )
                        }
                    </TblContainer>
                </Paper>
                {
                    showPageNtn ? <TblPagination /> : ''
                }
            </Paper>
        </>
    )
}

export default InProgressRepayments
